import React from 'react';
import type { FC } from 'react';
import {
  Text,
  Box,
  Link,
  UnorderedList,
  Learn,
  Rocket,
  PointerSmallIcon,
} from '@wix/cli-ui-kit';
import type { IPackageManager } from '@wix/package-manager';
import type { ProjectData } from '../hooks/create-project.js';

export const FinishedSuccessfullyMessage: FC<{
  packageManager: IPackageManager;
  folderName: string;
  projectData: ProjectData;
  siteId: string;
  isReleased: boolean;
}> = ({ packageManager, folderName, projectData, siteId, isReleased }) => {
  const businessManagerUrl = `https://manage.wix.com/dashboard/${siteId}`;

  return (
    <Box
      borderColor="blue"
      borderStyle="round"
      flexDirection="column"
      paddingY={1}
      paddingX={3}
      gap={1}
      marginLeft={-2}
      marginTop={1}
    >
      {isReleased && (
        <Box flexDirection="column" gap={1}>
          <Text bold>
            <Rocket /> Your site is live.
          </Text>
          <Box paddingLeft={2} flexDirection="column" gap={1}>
            <Box marginRight={1}>
              <PointerSmallIcon />
              <Box marginLeft={1} gap={1}>
                <Text>Visit site</Text>
                <Text skin="info">{projectData.baseUrl}</Text>
              </Box>
            </Box>
            <Box marginRight={1}>
              <PointerSmallIcon />
              <Box marginLeft={1} gap={1}>
                <Text>Open Business Manager</Text>
                <Text skin="info">{businessManagerUrl}</Text>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      <Text bold>Next Steps:</Text>

      <UnorderedList gap={1}>
        <UnorderedList.Item marker="👟">
          <Text>Start developing</Text>
          <Text skin="info">{`cd ${folderName}`}</Text>
          <Text skin="info">{`${packageManager.getRunCmd()} dev`}</Text>
        </UnorderedList.Item>

        <UnorderedList.Item marker={<Learn />}>
          <Text>For guides and API references visit our</Text>
          <Link skin="info" url="https://dev.wix.com/docs/go-headless">
            documentation
          </Link>
        </UnorderedList.Item>

        <UnorderedList.Item marker="💬">
          <Text>Join our</Text>
          <Link skin="info" url="https://discord.gg/wixstudio">
            Discord community
          </Link>
        </UnorderedList.Item>
      </UnorderedList>
    </Box>
  );
};
